import { FC } from "react";
import { ResourceDTO } from "utils/helpers/models/shared/resource.dto";
import useUtils from "hooks/useUtils";
import { PictureAltUnfilled, VideoAlt } from "assets/images/svgs";
import { MIME_TYPES } from "utils/helpers/enums/shared.enum";

interface Props {
    resource: ResourceDTO
}

const ResourceCard: FC<Props> = ({ resource }) => {
    const { downloadFileByUrl } = useUtils();

    const handleDownloadResource = () => {
        const { file } = resource;
        if (file?.fileDownloadUri) {
            downloadFileByUrl(file.fileDownloadUri);
        }
    }

    const getMimeType = (): MIME_TYPES => {
        if (resource.mimeType.includes(MIME_TYPES.IMAGE)) {
            return MIME_TYPES.IMAGE;
        } else {
            return MIME_TYPES.VIDEO;
        }
    }

    return (
       <div className="p-1 px-3 bg-white rounded-xl border border-borderColor flex flex-col h-full">

            <div className="relative">
                <img
                    src={resource?.thumbnail?.fileDownloadUri}
                    alt={resource.title}
                    className="w-full h-40 object-cover rounded-xl"
                />
                <div className="absolute top-2 left-2 bg-white text-center  p-2 rounded-md">
                    <span className="block text-sm font-bold text-primaryBlueText">
                        {resource.date}
                    </span>
                    <span className="block text-xs text-primaryBlueText">
                        {resource.month}
                    </span>
                </div>
                <div className="absolute top-2 right-2 bg-white text-center  p-1 rounded-md">
                    {getMimeType() === MIME_TYPES.VIDEO ? <VideoAlt title="Video" /> : <PictureAltUnfilled title="Picture" />}
                </div>
            </div>
            <div className="flex flex-col flex-grow py-2">
                <h3 className="text-lg font-semibold text-blackie">{resource.title}</h3>

                <div className="flex items-center mt-2 justify-between">
                    <div className="flex flex-wrap gap-2">
                        {resource.tags.map((tag, index) => (
                            <span
                                className="bg-fade rounded-md px-2 py-1 text-primaryBlueText"
                                key={index}
                            >
                                {tag}
                            </span>
                        ))}
                    </div>
                </div>

                <div className="w-full pt-5 mt-auto">
                    <button
                        className="w-full px-6 py-2 bg-fade text-primaryBlueText rounded-full hover:bg-primaryBlueText hover:text-white transition duration-300 ease-in-out flex items-center justify-center gap-2"
                        onClick={handleDownloadResource}
                    >
                        Download
                    </button>
                </div>
            </div>


        </div>
    )
}

export default ResourceCard;